module.exports = __webpack_public_path__ + "img/recupe_password.450c1216.jpg";